import React from 'react';
import { Col } from 'react-grid-system';
import PropTypes from 'prop-types';

import Section from '../Section';
import MarketoForm from '../MarketoForm';

function MarketoFormSection(props) {
  const {
    isNewsletter,
    title,
  } = props;

  return (
    <Section>
      <Col xs={12} md={6} push={{ md: 3 }}>
        {title && (
          <h2 data-test="title">{title}</h2>
        )}
        <div className={isNewsletter ? 'newsletter' : ''}>
          <MarketoForm {...props} />
        </div>
      </Col>
    </Section>
  );
}

export default MarketoFormSection;

MarketoFormSection.propTypes = {
  formId: PropTypes.string.isRequired,
  isNewsletter: PropTypes.bool,
  title: PropTypes.string,
};

MarketoFormSection.defaultProps = {
  isNewsletter: false,
  title: '',
};
